var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1e3a8a",
    width: "52px",
    height: "40px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "back to top") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.844 26.844h6.719c0.813 0 1.406-0.625 1.406-1.438v-7.813h5.313c0.5 0 0.875-0.25 1.063-0.719 0.063-0.156 0.063-0.25 0.063-0.375 0-0.313-0.094-0.563-0.313-0.781l-10.125-10.094c-0.344-0.469-1.125-0.438-1.563 0l-10.094 10.094c-0.688 0.625-0.219 1.875 0.813 1.875h5.344v7.813c0 0.813 0.563 1.438 1.375 1.438z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop);
export default __webpack_public_path__ + "static/media/top.06a9e41e2a609f0bf4ccae0905e6e46e.svg";
export { ForwardRef as ReactComponent };